// extracted by mini-css-extract-plugin
module.exports = {"author":"Bio-module--author--V87vA","authorLink":"Bio-module--authorLink--2JwFP","authorName":"Bio-module--authorName--3H6Oj","imageHolder":"Bio-module--imageHolder--2eQav"};